import React, { useEffect } from 'react';
import { shape, object, string, bool } from 'prop-types';
import { connect } from 'react-redux';
import { getURLParams } from '@widergy/web-utils/lib/browser';
import { UTLoading } from '@widergy/energy-ui';
import { push } from 'connected-react-router';

import { actionCreators as alertActions } from 'redux/alertHandlers';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { trackEvent } from 'services/AnalyticsService';
import { categories, actions, labels } from 'constants/analytics';
import { appConfig } from 'config/customization';

import {
  STATUS,
  REF_NUMBER,
  CHARGE_TOTAL,
  SUCCESS,
  FAILURE,
  AGENT_TRANSACTION_ID,
  TRANSACTION_TYPE
} from './constants';
import styles from './styles.module.scss';

const PaymentResult = ({ dispatch, location, sessionLoading, session }) => {
  useEffect(() => {
    if (!sessionLoading) {
      const params = getURLParams(location.search, STATUS, REF_NUMBER, CHARGE_TOTAL, AGENT_TRANSACTION_ID);
      const paymentStatus = location.pathname === ROUTES.PAYMENT_SUCCESS ? SUCCESS : FAILURE;
      const value = params[CHARGE_TOTAL] && parseInt(params[CHARGE_TOTAL], 0);
      const transactionId = params[AGENT_TRANSACTION_ID];
      trackEvent(
        categories.COBRANZAS,
        transactionId
          ? actions.GENERACION_PAGO_WHATSAPP
          : paymentStatus === SUCCESS
          ? actions.GENERACION_PAGO
          : actions.GENERACION_PAGO_ERRONEO,
        paymentStatus === SUCCESS ? labels.GENERACION_PAGO_OK : labels.GENERACION_PAGO_ERROR,
        value
      );
      const msg = message(`Payments:paymentResult${paymentStatus}`, {
        refNumber: params[REF_NUMBER] || ' ',
        status: params[STATUS] || ' ',
        chargeTotal: params[CHARGE_TOTAL] || ' '
      });
      dispatch(alertActions.openModal({ content: msg }));
      if (transactionId) {
        const agentMsg = message(`Payments:paymentResultWPP${paymentStatus}`, {
          refNumber: params[REF_NUMBER] || ' ',
          status: params[STATUS] || ' '
        });
        dispatch(
          paymentActions.sendAgentTransaction(TRANSACTION_TYPE, transactionId, [
            agentMsg,
            message(`Payments:thankForCommunicationWPP`)
          ])
        );
      }
      if (session) {
        dispatch(push(ROUTES.ACCOUNT_STATUS));
      } else {
        const route = appConfig.payments.publicPaymentByNis
          ? ROUTES.PUBLIC_PAYMENTS_BY_NIS
          : ROUTES.PUBLIC_PAYMENTS;
        dispatch(push(route));
      }
    }
  }, [sessionLoading, session]);

  return (
    <div className={styles.container}>
      <UTLoading loading={sessionLoading} />
    </div>
  );
};

PaymentResult.propTypes = {
  location: shape({
    pathname: string.isRequired,
    state: object,
    search: string
  }),
  sessionLoading: bool,
  session: bool
};

const mapStateToProps = store => ({
  sessionLoading: store.auth.sessionLoading,
  session: !store.auth.sessionLoading && !!store.auth.currentUser
});

export default connect(mapStateToProps)(PaymentResult);
